import React from 'react';

import { Column } from 'app/shopify/components/layout';

import { Checkbox, type CheckboxSize, type CheckboxState } from './Checkbox';

export interface CheckboxListOption {
  value: string;
  label: string;
  description?: string;
}

export interface CheckboxListProps {
  options: CheckboxListOption[];
  selectedValues?: string[];
  size?: CheckboxSize;
  state?: CheckboxState;
  onChange?: (value: string, checked: boolean) => void;
}

export function CheckboxList({
  options,
  selectedValues = [],
  size = 'small',
  state = 'enabled',
  onChange,
}: CheckboxListProps) {
  const listWidth = size === 'large' ? 168 : 153;
  const selectedValueSet = new Set(selectedValues);

  return (
    <Column width={listWidth} paddingVertical="spacing.general.x4" gap="spacing.general.x4">
      {options.map((option) => {
        const checked = selectedValueSet.has(option.value);
        return (
          <Checkbox
            key={option.value}
            size={size}
            state={state}
            label={option.label}
            description={option.description}
            showDescription={Boolean(option.description)}
            selected={checked}
            onPress={() => onChange?.(option.value, !checked)}
          />
        );
      })}
    </Column>
  );
}
